module.exports = __webpack_public_path__ + "static/media/cuong.9dc9b349.jpg";